import styled, { css } from 'styled-components';
import { Typography } from '../../../ui/Typography';
import { ellipsisText, FlexBetween } from '../../../../styled/common';
import { Breakpoints } from '../../../../styled/constants';

export const FooterContainer = styled.div`
  padding: 11px 15px 15px;

  @media (min-width: ${Breakpoints.tablet}px) {
    padding: 18px 20px;
  }
`;

const FooterText = styled(Typography)`
  color: ${({ theme }) => theme.colors.text.white};
`;

export const FooterPrice = styled(FooterText)`
  margin-top: 0;
  margin-bottom: 5px;

  @media (min-width: ${Breakpoints.tablet}px) {
    display: block;
    margin-bottom: 15px;
  }
`;

export const FooterDescription = styled(FooterText)`
  display: block;
  ${ellipsisText};
  margin-bottom: 5px;

  @media (min-width: ${Breakpoints.tablet}px) {
    margin-bottom: 22px;
  }
`;

export const kapitalBankButtonStyles = css`
  height: 40px;
  width: 160px;

  @media (min-width: ${Breakpoints.tablet}px) {
    height: 50px;
    width: 220px;
  }

  @media (min-width: ${Breakpoints.desktop}px) {
    width: 200px;
  }
`;

export const ActionsContainer = styled(FlexBetween)<{
  $isKapitalbankApplicable: boolean;
}>`
  ${({ $isKapitalbankApplicable }) =>
    !$isKapitalbankApplicable &&
    css`
      justify-content: flex-end;
    `}

  @media (min-width: ${Breakpoints.tablet}px) {
    justify-content: flex-start;
    gap: 20px;
  }
`;
